import React, { Component } from 'react'
import { i18nTranslate } from 'src/utils'
import { Button, Modal } from 'react-bootstrap'
import './styles.scss'

class ConversionFailPopup extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    const { isToShowPopUp = true, handleConversionFailPopup } = this.props

    return (
      <Modal
        show={isToShowPopUp}
        className="conversion-success-modal rounded-md">
        <Modal.Body className="conversion-success-modal">
          <h4 className="conversion-success-modal-title">
            {i18nTranslate(
              'becomeAMemberFailure.title',
              'Sorry, you are unable to become a Member at this time'
            )}
          </h4>
          <p>
            {i18nTranslate(
              'becomeAMemberFailure.message',
              'Business Entity accounts or joint BA accounts are not eligible to become a Member account online. Please contact distributor support or your account manager for more information.'
            )}
          </p>
          <Button
            className="acknowledge-button rounded-md"
            variant="outline-primary"
            data-testid="qa-exit-cancel-button"
            block
            onClick={handleConversionFailPopup}>
            {i18nTranslate('privacy.closeButton', 'Close')}
          </Button>
        </Modal.Body>
      </Modal>
    )
  }
}

export default ConversionFailPopup
export { ConversionFailPopup }
